export const MAIN_SEARCH = 'main-query';
export const OFFER_SEARCH = 'offer-search';
export const OFFER_SEARCH_HASH = 'offer-search-hash';
export const OFFER_SEARCH_BY_ALL_FOOD = 'offer-search-by-all-food';
export const MAIN_SEARCH_GRAPH = 'main-query-graph';
